<ng-container>
  <a
    [ngbTooltip]="'AuszugErstellen' | translate"
    [placement]="'top-end'"
    container="body"
    style="vertical-align: center; cursor: pointer; text-decoration: none">
    @if (isDownloading) {
      <span><i aria-hidden="true" class="fas fa-spinner fa-pulse fa-fw spinner"></i></span>
    } @else {
      <span><i (click)="createGrundstueckAuszug()" class="far fa-file-alt fa-1x"></i></span>
    }
  </a>
</ng-container>
